import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export const TAMANHO_MINIMO_DA_BUSCA = 2;

export default function useProductSearch({ q, limit = 20, enabled = true }) {
  const { getProducts } = useApiV2();
  const { user } = useAuth();
  const branchId = user?.active_branch_id ?? null;
  const termo = String(q || "").trim();

  return useQuery({
    queryKey: ["productSearch", user?.user_id ?? null, branchId, termo, limit],
    queryFn: () => getProducts({ branch_id: branchId, q: termo, limit }),
    enabled: enabled && !!branchId && termo.length >= TAMANHO_MINIMO_DA_BUSCA,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
    placeholderData: keepPreviousData,
  });
}
